"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestStatusBox = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classnames = require("classnames");
var __1 = require("../");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('RequestStatusBox'), (0, recompose_1.defaultProps)({
    statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'],
    status: 'STANDBY',
    position: 'top'
}), recompose_1.pure);
function getIcon(statusList, status) {
    switch (statusList.indexOf(status)) {
        case 1:
            return React.createElement(__1.Icon, { key: 'sending', className: "fas fa-circle-notch fa-spin" });
        case 2:
            return React.createElement(__1.Icon, { key: 'succeeded', className: "fa-check" });
        case 3:
            return React.createElement(__1.Icon, { key: 'failed', className: "fa-times" });
        default:
            return null;
    }
}
/**
 * Request status box
 * Status list: idle, fetching, fetched, failed
 */
exports.RequestStatusBox = enhance(function (props) {
    if (!props.statusList || props.statusList.length !== 4) {
        throw new Error('Expecting status list length to be 4');
    }
    if (!props.children || props.children.length !== 3) {
        throw new Error('Expecting children count to be 3');
    }
    var currentStatus = props.statusList.indexOf(props.status);
    return (React.createElement("div", { className: classnames('sok-request-status-box', props.position, "status-".concat(currentStatus), props.className) }, currentStatus > 0 ? (React.createElement("div", null,
        React.createElement("span", { className: "icon" }, getIcon(props.statusList, props.status)),
        props.children[currentStatus - 1])) : null));
});
//# sourceMappingURL=index.js.map